<div
  mdbModal
  #cartCustomizationModal="mdbModal"
  class="modal fade overflow-y-auto"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  [config]="{ ignoreBackdropClick: true }"
  (closed)="hideModal(false, false)"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <ng-template [cdkPortalOutlet]="portal" (attached)="onPortalAttached($event)"></ng-template>
    </div>
  </div>
</div>
